export enum BookingType {
  RoundTrip = 'RoundTrip',
  OneWay = 'OneWay',
  MultiCity = 'MultiCity',
}

export enum TravelClass {
  Economy = 'Economy',
  PremiumEconomy = 'PremiumEconomy',
  Business = 'Business',
  FirstClass = 'FirstClass',
}
export enum SpecialAssistanceType {
  CognitiveDisability = 'CognitiveDisability',
  HearingAssistance = 'HearingAssistance',
  BlindLowVision = 'BlindLowVision',
}

export enum MobilityAssistanceType {
  NeedWheelchair = 'NeedWheelchair',
  CanWalk = 'CanWalk',
  CannotWalk = 'CannotWalk',
  PersonalWheelchair = 'PersonalWheelchair',
}
export enum MedicalEquipmentType {
  Poc = 'Poc',
  OtherMedicalEquipment = 'OtherMedicalEquipment',
}
export enum MobilityDeviceType {
  ManualWheelchair = 'ManualWheelchair',
  DryGelCellBatteryWheelchairScooter = 'DryGelCellBatteryWheelchairScooter',
  WetCellBatteryWheelchairScooter = 'WetCellBatteryWheelchairScooter',
  LithiumBatteryWheelchairScooter = 'LithiumBatteryWheelchairScooter',
}
export interface AssistanceInformation {
  needAssistance: boolean
  mobilityAssistance: boolean
  mobilityAssistanceType: MobilityAssistanceType
  mobilityDevice: MobilityDeviceType
  specialAssistance: boolean
  specialAssistanceType: SpecialAssistanceType
  serviceAnimal: boolean
  medicalEquipment: boolean
  medicalEquipmentType: MedicalEquipmentType
}
export const DEFAULT_ASSISTANCE_INFORMATION: AssistanceInformation = {
  needAssistance: false,
  mobilityAssistance: false,
  mobilityAssistanceType: MobilityAssistanceType.NeedWheelchair,
  mobilityDevice: MobilityDeviceType.ManualWheelchair,
  specialAssistance: false,
  specialAssistanceType: SpecialAssistanceType.CognitiveDisability,
  serviceAnimal: false,
  medicalEquipment: false,
  medicalEquipmentType: MedicalEquipmentType.Poc,
}
export enum PassengerType {
  Adult = 'Adult',
  Child = 'Child',
  InfantInSeat = 'InfantOnSeat',
  InfantOnLap = 'InfantInLap',
}
export enum Gender {
  Male = 'Male',
  Female = 'Female',
}

export enum SortBy {
  Price = 'Price',
  DepartureTime = 'DepartureTime',
  ArrivalTime = 'ArrivalTime',
  Duration = 'Duration',
}
export enum StopsFilter {
  Any = 'Any',
  NonStop = 'Non-stop',
  OneStop = 'One-stop',
  TwoStops = 'Two-stops',
}
// Parameter defines the times range. It's a string containing two (for departure only) or four (for departure and arrival) comma-separated numbers. Each number represents the beginning of an hour. For example:
// 4,18: 4:00 AM - 7:00 PM departure
// 0,18: 12:00 AM - 7:00 PM departure
// 19,23: 7:00 PM - 12:00 AM departure
// 4,18,3,19: 4:00 AM - 7:00 PM departure, 3:00 AM - 8:00 PM arrival
// 0,23,3,19: unrestricted departure, 3:00 AM - 8:00 PM arrival
export type RawTimesFilter = `${number},${number}` | `${number},${number},${number},${number}`
export interface TimesFilter {
  departure: {
    from: number
    to: number
  }
  arrival: {
    from: number
    to: number
  }
}
